import React, { createContext, useContext, useMemo } from "react";
import { useSearchParams } from "react-router-dom";

import { resolveRegionId, PAYMENT_REGION_IDS } from "../constants/regionConfig";

const RegionContext = createContext(PAYMENT_REGION_IDS.INDIA);

export const RegionProvider = ({ children }) => {
  const [searchParams] = useSearchParams();
  const regionId = useMemo(
    () => resolveRegionId(searchParams.get("region_id")),
    [searchParams],
  );

  return (
    <RegionContext.Provider value={regionId}>{children}</RegionContext.Provider>
  );
};

export const useRegionId = () => useContext(RegionContext);
